import styled from 'styled-components';

export const ContactGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  max-width: 760px;
  margin: 0 auto;

  @media screen and (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const ContactCard = styled.div`
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 30px;
  box-shadow: var(--shadow-sm);
  text-align: left;
`;

export const ContactIcon = styled.div`
  width: 46px;
  height: 46px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: var(--accent-soft);
  color: var(--accent-strong);
  font-size: 1.3rem;
  margin-bottom: 18px;
`;

export const ContactLabel = styled.div`
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--muted);
  margin-bottom: 8px;
`;

export const ContactValue = styled.div`
  color: var(--ink);
  font-size: 1.05rem;
  font-weight: 600;
  line-height: 1.55;
`;

export const ContactEmail = styled.a`
  color: var(--accent-strong);
  font-size: 1.1rem;
  font-weight: 700;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;
